import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Box, Flex, Heading } from 'rebass/styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faTimes,
    faLongArrowAltLeft,
    faLongArrowAltRight,
} from '@fortawesome/free-solid-svg-icons'
import { modalToggle } from '../system/redux/reducers/modal'
import styled from 'styled-components'
import renderHTML from 'react-render-html'
import loadable from '@loadable/component'

const ModalContainer = styled(Flex)`
    align-items: center;
    background-color: rgba(0, 0, 0, 0.75);
    bottom: 0;
    justify-content: center;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 999;
`

const Modal = ({ dispatch, isOpen, content }) => {
    const [pageContent, setContent] = useState(null)
    useEffect(() => {
        if (content) {
            const RenderedModule = loadable((props) =>
                import(`../modules/${content.item.module}`)
            )
            setContent(<RenderedModule {...content.item.props} />)
        }
    }, [content])

    return (
        <>
            {isOpen && (
                <ModalContainer>
                    <Box
                        onClick={() =>
                            dispatch(
                                modalToggle(
                                    JSON.stringify({
                                        isOpen: false,
                                        content: false,
                                    })
                                )
                            )
                        }
                        sx={{
                            cursor: 'pointer',
                            position: 'absolute',
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0,
                            zIndex: -1,
                        }}
                    />

                    <Flex
                        alignItems='center'
                        bg='greyLight'
                        justifyContent='center'
                        pl='sm'
                        pr='sm'
                        pb='sm'
                    >
                        <Box
                            id='modalPublicationsLeft'
                            pr='md'
                            color='red'
                            sx={{
                                cursor: 'pointer',
                            }}
                        >
                            <FontAwesomeIcon icon={faLongArrowAltLeft} />
                        </Box>
                        <Flex
                            alignItems='center'
                            flexDirection='column'
                            justifyContent='center'
                            height='100%'
                            // width='100%'
                        >
                            <Flex
                                width='100%'
                                pb='sm'
                                pt='sm'
                                justifyContent='flex-end'
                            >
                                <Box
                                    onClick={() =>
                                        dispatch(
                                            modalToggle(
                                                JSON.stringify({
                                                    isOpen: false,
                                                    content: false,
                                                })
                                            )
                                        )
                                    }
                                    color='red'
                                    sx={{
                                        cursor: 'pointer',
                                    }}
                                >
                                    <FontAwesomeIcon icon={faTimes} />
                                </Box>
                            </Flex>
                            <Box
                                bg='greyLight'
                                height={[
                                    '212px',
                                    '289px',
                                    '337px',
                                    '473px',
                                    '637px',
                                    '707px',
                                    '778px',
                                ]}
                                width={[
                                    '300px',
                                    '380px',
                                    '476px',
                                    '668px',
                                    '900px',
                                    '1000px',
                                    '1100px',
                                ]}
                            >
                                {pageContent}
                            </Box>
                            <Flex
                                pt='sm'
                                pb='md'
                                justifyContent='space-between'
                                width='100%'
                            >
                                <Heading as='h2' variant='h2'>
                                    {content.title}
                                </Heading>
                                <Box width='40%' textAlign='right'>
                                    {renderHTML(content.description || '')}
                                </Box>
                            </Flex>
                        </Flex>
                        <Box
                            id='modalPublicationsRight'
                            pl='md'
                            color='red'
                            sx={{
                                cursor: 'pointer',
                            }}
                        >
                            <FontAwesomeIcon icon={faLongArrowAltRight} />
                        </Box>
                    </Flex>
                </ModalContainer>
            )}
        </>
    )
}
function mapStateToProps(state) {
    return {
        isOpen: state.Modal.isOpen,
        content: state.Modal.content,
    }
}

export default connect(mapStateToProps)(Modal)
